
import { Box, MenuItem, TextField } from '@mui/material'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import React, { useCallback, useState, useContext, useEffect } from 'react'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
import SearchButton from 'components/buttons/SearchButton'
import ClearButton from 'components/buttons/ClearButton'
import { initFilterData, clearFilterData } from './initData'
import { addIdForDataGrid } from 'utils'
import { sparePartApiNm, sparePartColNm } from './constant'
import AddButton from 'components/buttons/AddButton'
import SparePartDialog from './SparePartDialog'
import SparePartTypeDialog from './SparePartTypeDialog'
import { sparePartColumns } from './columns'
import { Button } from '@mui/material'

let selectedId = null
let lastFilter = null

const SparePartManagement = () => {
  const { ax } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [typeDialogOpen, setTypeDialogOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initFilterData })
  const [sparePartTypes, setSparePartTypes] = useState([])

  const getData = useCallback((filter) => {
    ax.post(sparePartApiNm.getSparePart, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'SpId'))
        lastFilter = filter
      }
    })
  }, [ax])

  const textFieldProps = useCallback((name) => ({
    size: "small",
    label: sparePartColNm[name],
    value: filterData[name] ?? "",
    onChange: (e) => setFilterData(o => ({ ...o, [name]: e.target.value || null })),
    onKeyUp: (e) => { if (e.key === 'Enter') getData(filterData) },
  }), [filterData, getData])

  const handleCellClick = useCallback((params) => {
    if (params.field === 'ShowDetail') {
      selectedId = params.id
      setDialogOpen(true)
    }
  }, [])

  const handleRowDoubleClick = useCallback((params) => {
    selectedId = params.id
    setDialogOpen(true)
  }, [])

  const onFinish = useCallback((data) => {
    if (data) {
      setDataTable(addIdForDataGrid(data, 'SpId'))
    } else {
      getData(lastFilter)
    }
  }, [getData])

  const handleAdd = useCallback(() => {
    selectedId = null
    setDialogOpen(true)
  }, [])

  const loadSparePartTypes = useCallback(() => {
    ax.post(sparePartApiNm.getSparePartType, { IsActv: 1 }).then(value => {
      if (value.data) {
        setSparePartTypes(value.data)
      }
    })
  }, [ax])

  const onTypeFinish = useCallback(() => {
    loadSparePartTypes()
  }, [loadSparePartTypes])

  useEffect(() => {
    getData({ ...initFilterData })
    loadSparePartTypes()
  }, [getData, loadSparePartTypes])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <AddButton onClick={handleAdd}>เพิ่มอะไหล่</AddButton>
        <Button variant="contained" onClick={() => setTypeDialogOpen(true)}>ประเภทอะไหล่</Button>
        <Box flex={1} />
        <TextField {...textFieldProps("SpTypId")} label="ประเภท" select sx={{ width: 150 }}
          onChange={(e) => setFilterData(o => ({ ...o, SpTypId: e.target.value || null }))}>
          <MenuItem value="">ทั้งหมด</MenuItem>
          {sparePartTypes.map(t => (
            <MenuItem key={t.SpTypId} value={t.SpTypId}>{t.SpTypNm}</MenuItem>
          ))}
        </TextField>
        <TextField {...textFieldProps("IsActv")} label="สถานะ" select sx={{ width: 120 }}
          onChange={(e) => setFilterData(o => ({ ...o, IsActv: e.target.value }))}>
          <MenuItem value={null}>ทั้งหมด</MenuItem>
          <MenuItem value={1}>ใช้งาน</MenuItem>
          <MenuItem value={0}>ไม่ใช้งาน</MenuItem>
        </TextField>
        <TextField {...textFieldProps("SpCd")} label="รหัส" />
        <TextField {...textFieldProps("SpNm")} label="ชื่ออะไหล่" />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearFilterData })} />
      </BoxFR>
      <Box height='100%'>
        <DataGridCellExpand
          hideFooter
          rows={dataTable}
          columns={sparePartColumns}
          onRowDoubleClick={handleRowDoubleClick}
          onCellClick={handleCellClick}
        />
      </Box>
      <SparePartDialog
        selectedId={selectedId}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        onFinish={onFinish}
        lastFilter={lastFilter}
        sparePartTypes={sparePartTypes}
      />
      <SparePartTypeDialog
        dialogOpen={typeDialogOpen}
        setDialogOpen={setTypeDialogOpen}
        onFinish={onTypeFinish}
      />
    </BoxFC>
  )
}

export default SparePartManagement
